module.exports = __webpack_public_path__ + "static/media/fire.9d08ae85.png";